export interface LegalIdentityConfig {
  entityName: string | null;
  contactEmail: string | null;
  contactPhone: string | null;
}

function configured(value: string | undefined): string | null {
  const normalized = value?.trim() ?? "";
  return normalized || null;
}

export function legalIdentityFromEnvironment(env: ImportMetaEnv): LegalIdentityConfig {
  return {
    entityName: configured(env.VITE_LEGAL_ENTITY_NAME),
    contactEmail: configured(env.VITE_CONTACT_EMAIL),
    contactPhone: configured(env.VITE_CONTACT_PHONE),
  };
}

export function validateLegalReleaseEnvironment(env: Record<string, string | undefined>): string[] {
  const issues: string[] = [];
  const entityName = configured(env.VITE_LEGAL_ENTITY_NAME);
  const contactEmail = configured(env.VITE_CONTACT_EMAIL);
  const contactPhone = configured(env.VITE_CONTACT_PHONE);
  if (!entityName || entityName === "琴景网络" || entityName.length < 4) {
    issues.push("VITE_LEGAL_ENTITY_NAME must be the confirmed legal entity name, not the operating short name.");
  }
  if (!contactEmail || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contactEmail)) {
    issues.push("VITE_CONTACT_EMAIL must be a monitored public contact address.");
  }
  if (contactPhone && !/^\+?[0-9 -]{6,20}$/.test(contactPhone)) {
    issues.push("VITE_CONTACT_PHONE must be a valid public contact number when configured.");
  }
  if (env.VITE_LEGAL_REVIEW_CONFIRMED !== "true") {
    issues.push("VITE_LEGAL_REVIEW_CONFIRMED=true is required after the legal content is approved for release.");
  }
  if (env.VITE_ICP_SCOPE_CONFIRMED !== "true") {
    issues.push("VITE_ICP_SCOPE_CONFIRMED=true is required after confirming the filing covers the production domain and operator relationship.");
  }
  return issues;
}
